import { ProductIcon } from "../core/components/ProductIcon";
import { useFormatUserDate } from "../core/useFormatUserDate";
import { getProductName } from 'legoland-sdk';
import { UserRole } from 'legoland-sdk/dist/experimental';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Box, Button, Heading, InlineText, Text, TooltipOnHover, tombac } from 'tombac';
import { AcceptIcon, DeleteIcon, EditIcon, EmailIcon, SpinnerIcon, WhatsNewIcon } from 'tombac-icons';
import { CommunicationMessage } from "./CommunicationMessage";
import { CommunicationType } from "./communicationTypes";
import { useCommunicationDate } from "./helpers/useCommunicationDate";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const CommunicationListItem = _ref => {
  let {
    communicationItem,
    onDeleteClick,
    onEditClick,
    onSendEmailClick
  } = _ref;
  const date = useCommunicationDate(communicationItem.date);
  const formatUserDateTime = useFormatUserDate({
    withTime: true
  });
  const emails = communicationItem.emails;
  return /*#__PURE__*/_jsxs(Container, {
    "data-sentry-element": "Container",
    "data-sentry-component": "CommunicationListItem",
    "data-sentry-source-file": "CommunicationListItem.tsx",
    children: [/*#__PURE__*/_jsxs(Box, {
      $alignItems: "center",
      $display: "flex",
      $gap: "2sp",
      $mb: "2sp",
      "data-sentry-element": "Box",
      "data-sentry-source-file": "CommunicationListItem.tsx",
      "data-sentry-element": "Box",
      children: [/*#__PURE__*/_jsx(Heading, {
        as: "h2",
        level: 4,
        "data-sentry-element": "Heading",
        "data-sentry-source-file": "CommunicationListItem.tsx",
        "data-sentry-element": "Heading",
        children: date
      }), /*#__PURE__*/_jsx(Box, {
        $display: "flex",
        $gap: "1sp",
        "data-sentry-element": "Box",
        "data-sentry-source-file": "CommunicationListItem.tsx",
        "data-sentry-element": "Box",
        children: communicationItem.products.map(p => ({
          id: p,
          displayName: getProductName(p)
        })).sort((a, b) => a.displayName.localeCompare(b.displayName)).map(product => /*#__PURE__*/_jsx(TooltipOnHover, {
          content: product.displayName,
          contentContainerProps: {
            $display: 'flex'
          },
          placement: "top",
          size: "s",
          children: /*#__PURE__*/_jsx(ProductIcon, {
            height: 24,
            productId: product.id,
            width: 24
          })
        }, product.id))
      }), /*#__PURE__*/_jsxs(Box, {
        $alignItems: "center",
        $display: "flex",
        $ml: "auto",
        "data-sentry-element": "Box",
        "data-sentry-source-file": "CommunicationListItem.tsx",
        "data-sentry-element": "Box",
        children: [emails && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(Text, {
            $color: emails.waiting === 0 ? tombac.color('success') : undefined,
            $mr: "0.5sp",
            as: "span",
            children: emails.waiting === 0 ? /*#__PURE__*/_jsx(AcceptIcon, {
              size: "xs"
            }) : /*#__PURE__*/_jsx(SpinnerIcon, {
              spin: true,
              size: "xs"
            })
          }), /*#__PURE__*/_jsxs(Text, {
            $alignItems: "center",
            $color: tombac.color('neutral', 700),
            $display: "flex",
            as: "div",
            size: "s",
            children: ["Email sent to", ' ', emails.sent === emails.totalElements ? emails.sent : `${emails.sent} / ${emails.totalElements}`, ' ', "users"]
          })]
        }), onSendEmailClick && !emails && /*#__PURE__*/_jsx(TooltipOnHover, {
          content: "Send communication email",
          contentContainerProps: {
            $ml: '1sp'
          },
          placement: "top",
          size: "s",
          children: /*#__PURE__*/_jsx(Button, {
            onClick: () => onSendEmailClick(communicationItem),
            shape: "circle",
            size: "s",
            variant: "flat",
            children: /*#__PURE__*/_jsx(EmailIcon, {})
          })
        }), onEditClick && /*#__PURE__*/_jsx(TooltipOnHover, {
          content: "Edit",
          contentContainerProps: {
            $ml: '1sp'
          },
          placement: "top",
          size: "s",
          children: /*#__PURE__*/_jsx(Button, {
            onClick: () => onEditClick(communicationItem),
            shape: "circle",
            size: "s",
            variant: "flat",
            children: /*#__PURE__*/_jsx(EditIcon, {})
          })
        }), onDeleteClick && /*#__PURE__*/_jsx(TooltipOnHover, {
          content: "Delete",
          contentContainerProps: {
            $ml: '1sp'
          },
          placement: "top",
          size: "s",
          children: /*#__PURE__*/_jsx(Button, {
            onClick: () => onDeleteClick(communicationItem),
            shape: "circle",
            size: "s",
            variant: "flat",
            children: /*#__PURE__*/_jsx(DeleteIcon, {})
          })
        })]
      })]
    }), /*#__PURE__*/_jsxs(Box, {
      $alignItems: "center",
      $display: "flex",
      $mb: "1sp",
      "data-sentry-element": "Box",
      "data-sentry-source-file": "CommunicationListItem.tsx",
      "data-sentry-element": "Box",
      children: [/*#__PURE__*/_jsx(Text, {
        $display: "inline-block",
        $mr: "1sp",
        as: "div",
        "data-sentry-element": "Text",
        "data-sentry-source-file": "CommunicationListItem.tsx",
        "data-sentry-element": "Text",
        children: communicationItem.type === CommunicationType.ReleaseNotes ? /*#__PURE__*/_jsx(TooltipOnHover, {
          content: "Release notes",
          placement: "top",
          size: "s",
          children: /*#__PURE__*/_jsx(WhatsNewIcon, {
            fixedWidth: false
          })
        }) : /*#__PURE__*/_jsx(TooltipOnHover, {
          content: "Email only",
          placement: "top",
          size: "s",
          children: /*#__PURE__*/_jsx(EmailIcon, {
            fixedWidth: false
          })
        })
      }), /*#__PURE__*/_jsxs(Text, {
        size: "s",
        "data-sentry-element": "Text",
        "data-sentry-source-file": "CommunicationListItem.tsx",
        "data-sentry-element": "Text",
        children: [/*#__PURE__*/_jsx("strong", {
          children: "Visible for:"
        }), ' ', /*#__PURE__*/_jsx(InlineText, {
          $color: tombac.color('neutral', 700),
          $display: "inline",
          as: "span",
          size: "s",
          "data-sentry-element": "InlineText",
          "data-sentry-source-file": "CommunicationListItem.tsx",
          "data-sentry-element": "InlineText",
          children: communicationItem.roles.length === Object.keys(UserRole).length ? 'All users' : communicationItem.roles.sort().map(role => Object.entries(UserRole).find(_ref2 => {
            let [, value] = _ref2;
            return value === role;
          })?.[0]).join(', ')
        })]
      })]
    }), /*#__PURE__*/_jsx(CommunicationMessage, {
      communicationItem: communicationItem,
      "data-sentry-element": "CommunicationMessage",
      "data-sentry-source-file": "CommunicationListItem.tsx",
      "data-sentry-element": "CommunicationMessage"
    }), /*#__PURE__*/_jsxs(Box, {
      $mb: "2sp",
      "data-sentry-element": "Box",
      "data-sentry-source-file": "CommunicationListItem.tsx",
      "data-sentry-element": "Box",
      children: [/*#__PURE__*/_jsxs(Text, {
        size: "s",
        variant: "secondary",
        "data-sentry-element": "Text",
        "data-sentry-source-file": "CommunicationListItem.tsx",
        "data-sentry-element": "Text",
        children: ["Added by", ' ', /*#__PURE__*/_jsx(InlineText, {
          as: Link,
          size: "s",
          to: `/users/edit/${encodeURIComponent(communicationItem.createdBy)}`,
          variant: "interactive",
          "data-sentry-element": "InlineText",
          "data-sentry-source-file": "CommunicationListItem.tsx",
          "data-sentry-element": "InlineText",
          children: communicationItem.createdBy
        }), ' ', "at ", formatUserDateTime(communicationItem.createdAt)]
      }), isCommunicationModified(communicationItem) && /*#__PURE__*/_jsxs(Text, {
        size: "s",
        variant: "secondary",
        children: ["Last modified by", ' ', /*#__PURE__*/_jsx(InlineText, {
          as: Link,
          size: "s",
          to: `/users/edit/${encodeURIComponent(communicationItem.lastModifiedBy)}`,
          variant: "interactive",
          children: communicationItem.lastModifiedBy
        }), ' ', "at ", formatUserDateTime(communicationItem.lastModifiedAt)]
      })]
    })]
  });
};

/**
 * Checks if a communication item has been modified since it was created.
 *
 * @param communication - The communication item to check.
 * @returns Returns `true` if the communication item has been modified,
 *   otherwise `false`.
 */
function isCommunicationModified(communication) {
  return communication.lastModifiedBy && (communication.lastModifiedBy !== communication.createdBy || communication.lastModifiedAt !== communication.createdAt);
}
const Container = styled.div.withConfig({
  displayName: "CommunicationListItem__Container"
})(["border-bottom:1px solid ", ";padding:", ";&:last-child{border-bottom:none;}"], tombac.color('neutral', 400), tombac.space(3, 0));